import Handlebars from "handlebars";

Handlebars.registerHelper("gridLayout", function (slides, options) {
  var maxGridWidth = 1010;
  var minFullSizeWidth = 1010;
  var totalColumnWidth = 12;
  var maxGroupColumnSize = 4;
  var minGridSpanSize = 3;
  var approximateColumnWidth = 83.8889;

  var buffer = "";

  var currentIndex = 0;

  var imageGroups = populateGroups(slides);

  // loop through the rows array
  for (var i = 0; i < imageGroups.length; i++) {
    var startIndex = currentIndex;
    var endIndex = startIndex + imageGroups[i];

    currentIndex = endIndex;

    // write out the opening row HTML for the row
    buffer += '<div class="row">';

    var rowSlides = imageGroups[i];

    //loop through the slides for this row
    for (var j = 0; j < rowSlides.length; j++) {
      var rowSlide = rowSlides[j];

      // write out the template block for each slide
      buffer += options.fn(rowSlide);
    }

    // write out the closing row HTML for the row
    buffer += '<div class="drawer col span_12" id="row-content" style="display: none;"><p></p></div>';
    buffer += "</div>";
  }

  return buffer;

  //populate image groups for each row with the appropriate number of images per row (based on width of each image)
  function populateGroups(slides) {
    var groups = [];
    var group = [];

    var groupColumnWidth = 0;

    // loop through the slides
    for (var i = 0; i < slides.length; i++) {
      var slide = slides[i];

      // add an index to each slide object
      slide.imgIndex = i + 1;

      // Get the number of columns the image would occupy
      var columnWidth = getGridColumnWidth(slide);

      // Determine the total width of columns if we add image to row
      groupColumnWidth += columnWidth;

      // If the image would push the columns over the limit
      // or if the max number of images have been added to the list
      if (groupColumnWidth > totalColumnWidth || group.length == maxGroupColumnSize) {
        // We remove the column count of the image
        var existingColumnWidth = groupColumnWidth - columnWidth;

        // and determine the number of remaining columns
        var diff = totalColumnWidth - existingColumnWidth;

        // We finish group, but do not add new image
        groups.push(adjustGridColumns(group, diff));

        // And start a new group
        group = [];

        slide.columnWidth = columnWidth;

        // by adding the new image already
        group.push(slide);

        // and setting the group width
        groupColumnWidth = columnWidth;

        if (i == slides.length - 1) {
          diff = totalColumnWidth - groupColumnWidth;
          groups.push(adjustGridColumns(group, diff));
        }

        // else if we get exact numbers of columns
      } else if (groupColumnWidth == totalColumnWidth) {
        slide.columnWidth = columnWidth;

        // We add the image to the group
        group.push(slide);

        // We add the group to the list
        groups.push(group);

        // And reset groups
        group = [];

        groupColumnWidth = 0;
      } else {
        slide.columnWidth = columnWidth;

        group.push(slide);

        if (i == slides.length - 1) {
          diff = totalColumnWidth - groupColumnWidth;
          groups.push(adjustGridColumns(group, diff));
        }
      }
    }

    return groups;
  }

  function getGridColumnWidth(image) {
    var width = image.width / 2;

    if (width >= minFullSizeWidth) {
      return totalColumnWidth;
    } else {
      var result = Math.round(width / approximateColumnWidth);

      return result < minGridSpanSize ? minGridSpanSize : result;
    }
  }

  function adjustGridColumns(group, diff) {
    if (diff < 1) {
      return group;
    }

    //loop through the images in this group and increase each of their column widths
    for (var i = 0; i < group.length; i++) {
      if (diff == 0) {
        break;
      }
      group[i].columnWidth += 1;
      diff -= 1;
    }

    return group;
  }
});
